module.exports = __webpack_public_path__ + "img/symbol-calendar-center.cbdab594.png";